/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */

import './TransactionsPage.scss';

import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { PageHeader } from '../Header/PageHeader';

import LegalCopy from 'components/shared/LegalCopy/LegalCopy';
import Content from 'services/Content';
import { isMoneyMarketCutoffEnabled } from 'services/FeatureFlags';
import TransactionHistoryTable from "components/layouts/Transaction/TransactionPageV2/TransactionHistoryTable";
import {
  getHistoricalTransactionTable, getPendingTransactionsTable,
  getTransactionsHistoryFilteringSelections
} from "../../../state/transaction/TransactionSelectors";
import TransactionPendingTableV2 from "../../layouts/Transaction/TransactionPageV2/TransactionPendingTableV2";

export const TransactionsPageV2 = ({
                                     transactionHistory,
                                     transactionHistoryFilteringSelections,
                                     pendingTransactions
}) => {
  return (
    <div className={'transactions-page-v2'}>
      <div className="beacon-on-light">
        <PageHeader title="Activity V2" />
        <h2 className={'b-color-text--title b-typography-serif--headline--500 b-font-weight-bold b-margin-block-end--micro--maxi'}>Pending transactions</h2>
        <TransactionPendingTableV2
          pendingTransactionTableData={pendingTransactions}
          filterOptions={[]}
        />
        <h2 className="b-color-text--title b-typography-serif--headline--500 b-font-weight-bold b-margin-block-end--micro--maxi">Transaction history</h2>
        <TransactionHistoryTable
          transactionHistoryTableData={transactionHistory}
          filterOptions={transactionHistoryFilteringSelections}
        />
        {/* TODO: Need to update with new/correct legal copy */}
        <Fragment>
          <LegalCopy
            content={
              (isMoneyMarketCutoffEnabled() ? Content.transactionsMoneyMarketLegalCopy : Content.transactionsLegalCopy)
            }
          />
        </Fragment>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  transactionHistory: getHistoricalTransactionTable(state),
  transactionHistoryFilteringSelections:
    getTransactionsHistoryFilteringSelections(state),
  pendingTransactions: getPendingTransactionsTable(state)
});

export default withRouter(connect(mapStateToProps)(TransactionsPageV2));
